/**
 * AI Platform
 * Chat API of the hosted agent server (`@convercus/agent-server`). Read a chat as a view: a snapshot from `GET /chats/{chatId}/view`, then its changes from the NDJSON stream `GET /chats/{chatId}/view/stream?after` or the long-poll `GET /chats/{chatId}/view?after&waitMs`. The service sits behind the API gateway, which validates the JWT and forwards identity as plain headers — `program`, `user-id`, `username` and the user\'s `roles`. The view stream is the exception: it is reached without the gateway and verifies the `Authorization: Bearer` token itself. With `AUTH_MODE=mock` (local dev) every request runs as a canned identity and the headers are ignored. Every route but health names the permission it needs and answers 403 to a role that grants none of them: `agent.bi` (ANALYTICS, SUPER_ADMIN) for agents and chats; `agent.config.read`/`agent.config.write` (PROGRAM_MANAGER, SUPER_ADMIN) for the settings; dedicated mode and the spend ledger are SUPER_ADMIN only.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SendNowResult { 
    /**
     * `steered` (busy: it joins the running answer after its current tool round), `started` (idle: it is placed and a new answer starts), or `already_placed`, `settled`, `not_found`.
     */
    result: SendNowResult.ResultEnum;
}
export namespace SendNowResult {
    export type ResultEnum = 'steered' | 'started' | 'already_placed' | 'settled' | 'not_found';
    export const ResultEnum = {
        Steered: 'steered' as ResultEnum,
        Started: 'started' as ResultEnum,
        AlreadyPlaced: 'already_placed' as ResultEnum,
        Settled: 'settled' as ResultEnum,
        NotFound: 'not_found' as ResultEnum
    };
}


